import React, { useState } from "react";

import { NewsData } from "../News/News.data";
import { Modal, Image, Panel, Button, SectionHeading } from "../../design-system";

const Shows = () => {
  const [gigs] = useState(NewsData.filter((item) => item.gig));
  const [modalImage, setModalImage] = useState<string>("images/flyer_20112026.jpeg");
  const [showModal, setShowModal] = useState<boolean>(true);

  const onContainerClick = (imageUrl: string) => {
    setModalImage(imageUrl);
    setShowModal(true);
  };

  return (
    <section className="min-w-0 scroll-mt-[25px]" aria-labelledby="shows-title">
      <SectionHeading id="shows-title" title="SHOWS" eyebrow="LIVE ARCHIVE" number="02 / LIVE" compact className="mx-auto max-w-[580px]" />
      <div className="mx-auto grid w-full max-w-[580px] grid-cols-1 gap-5 text-white">
        {gigs.map((news, i) => (
          <Panel className="flex w-full flex-col items-center p-[clamp(18px,3vw,28px)] text-center text-white" key={i}>
            <b className="text-xs font-extrabold uppercase tracking-[.16em] text-date">
              {news.gig?.dayOfWeek}, {news.gig?.date}
            </b>
            <Image variant="fluid" className="mx-auto my-[18px] block w-full" src={news.gig?.flyerUrl} alt={`Flyer for ${news.gig?.festivalName}`} loading="lazy" />
            <b className="mb-1 text-[13px] uppercase">
              {news.gig?.city} - {news.gig?.state} BRASIL
            </b>
            <p className="mb-4 text-xs text-muted">{news.gig?.festivalName}</p>
            <Button variant="outline" size="detail" fullWidth
              type="button"
              className="mt-auto justify-center"
              onClick={() => onContainerClick(news.gig?.flyerUrl!)}
            >
              DETALHES <span aria-hidden="true">↗</span>
            </Button>
          </Panel>
        ))}
      </div>

      {showModal && (
        <Modal
          onClose={() => setShowModal(false)}
          isOpen={true}
          children={<Image variant="preview" src={modalImage} alt="Flyer" />}
        />
      )}
    </section>
  );
};

export default Shows;
